export default __webpack_public_path__ + "static/media/DinosaursHerbivores_06.616a514c.png";